import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "finish-input" }
const _hoisted_2 = { class: "finish-input__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "finish-input__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__prefix" }
const _hoisted_6 = { class: "sub-title__suffix" }
const _hoisted_7 = { class: "finish-input__linking-container" }
const _hoisted_8 = { class: "finish-input__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import InputExcelForm from '../inputExcelForm/InputExcelForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'FinishInput',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');

const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-3.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-3.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-3__en.png') : imagesRequire('./register-input-step-flow-3.png');
  },
  {
    immediate: true,
  }
);

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadInput.headerCandidates.map((candidate) => candidate.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引紐付け：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "finish-input__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('取引紐付け：本文')), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引紐付け：注釈')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(InputExcelForm, {
        from: 'FinishInput',
        "selected-field-id": selectedFieldId.value,
        suggestions: selectedFieldSuggestions.value,
        "input-file-type": _unref(state).uploadInput.inputFileType,
        "use-format-type": _unref(state).uploadInput.useFormatType,
        "alterable-header-infos": _unref(state).linkingInput.alternateHeaderInfos,
        "inlined-year-month-info": _unref(state).linkingInput.inlinedYearMonthInfo,
        "in-header-year-month-info": _unref(state).linkingInput.inHeaderYearMonthInfo
      }, null, 8, ["selected-field-id", "suggestions", "input-file-type", "use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})